import { getSharedStyleSheet } from './sharedStyleSheet.js';

class FileThumb extends HTMLElement {
    static observedAttributes = ['src', 'file-title', 'hover-src', 'frame-width', 'size', 'type'];

    constructor() {
        super();

        this.obj = null;
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open'});
        }

        // Make sure element obeys parent sizing
        this.shadowRoot.host.style.display = 'inline-block';

        this.render();
    }

    disconnectedCallback() {
        if (this.obj) {
            this.obj.removeEventListener('mousemove', this.hoverScrub.bind(this));
            this.obj = null;
        }
    }

    resizeTextToFit(element)
    {
        if (!element || !element.length || typeof element == 'undefined') return;

        // We only want to scale down long text, so first we reset
        // font-size to 100%, in case this function is called multiple times.
        element.style.fontSize = '100%';
        element.style.letterSpacing = '';

        let fontSize = 100;
        let letterSpacing = parseFloat(element.style.letterSpacing);

        while (element[0].scrollWidth > element[0].clientWidth) {
            fontSize--;
            element.style.fontSize = fontSize + '%';
            element.style.letterSpacing = (letterSpacing * (fontSize / 100)) + 'px';

            if (fontSize <= 78) break;
        }
    }

    render() {
        // Share a single parsed stylesheet across all shadow roots
        getSharedStyleSheet().then(sheet => {
            this.shadowRoot.adoptedStyleSheets = [sheet];
        });

        this._wrapperElement = document.createElement('div');
        this._wrapperElement.className = 'file-thumb-wrapper';
        this._wrapperElement.style.display = 'flex';
        this._wrapperElement.style.alignItems = 'center';
        this._wrapperElement.style.justifyContent = 'flex-start';

        this._thumbElement = document.createElement('thumbnail-image');
        this._thumbElement.style.flexShrink = '0';

        this._wrapperElement.appendChild(this._thumbElement);

        this._titleElement = document.createElement('div');
        this._titleElement.className = 'file-thumb-title';
        this._wrapperElement.appendChild(this._titleElement);

        this.shadowRoot.append(this._wrapperElement);

        // Listen for mouse move
        if (!!this.getAttribute('hover-src')) {
            const thumbObj = this.shadowRoot.querySelector('.file-thumb');
            thumbObj.addEventListener('mousemove', this.hoverScrub.bind(this));
            this.obj = thumbObj;
        }

        this.dynamicRender();
    }

    dynamicRender() {
        if (!this._wrapperElement || !this._thumbElement) return;

        let src = this.getAttribute('src') ?? '';

        let title = this.getAttribute('file-title') ?? '';

        if (title && title.length > 50) {
            title = title.substr(0, 50) + "...";
        }

        this._thumbElement.setAttribute('src', src);
        this._thumbElement.setAttribute('file-type', this.getAttribute('type') ?? '');

        this._thumbElement.classList.remove('small');
        this._thumbElement.classList.remove('mini');
        this._thumbElement.classList.remove('micro');

        if (!!this.getAttribute('size')) {
            this._thumbElement.setAttribute('size', this.getAttribute('size'));
            this._thumbElement.classList.add(this.getAttribute('size'));
        }

        if (!!this.getAttribute('hover-src')) {
            this._thumbElement.setAttribute('hover-src', this.getAttribute('hover-src') ?? '');
        }

        if (title) {
            this._titleElement.textContent = title;

            this._titleElement.classList.remove('small');
            this._titleElement.classList.remove('mini');
            this._titleElement.classList.remove('micro');

            if (!!this.getAttribute('size')) {
                this._titleElement.classList.add(this.getAttribute('size'));
            }

            const textObj = this.shadowRoot.querySelector('.file-thumb-title');
            this.resizeTextToFit(textObj);
        }
    }
}

customElements.define('file-thumb', FileThumb);